import { createI18n } from 'vue-i18n';
import { storage } from '@/utils';
import { Locale } from 'vant';
import vantZh from 'vant/es/locale/lang/zh-CN';
import vantEn from 'vant/es/locale/lang/en-US';
import vantEs from 'vant/es/locale/lang/es-ES';
import es from './locales/es';
import zh from './locales/zh';
import en from './locales/en';

// Vant 内置组件文案(比如 Dialog 的 取消/确认 按钮)对应表
const VANT_LOCALES = {
  zh: { key: 'zh-CN', pack: vantZh },
  en: { key: 'en-US', pack: vantEn },
  es: { key: 'es-ES', pack: vantEs },
};

// 把 Vant 内置文案切到对应语言
function applyVantLocale(locale) {
  const conf = VANT_LOCALES[locale];
  if (!conf) return;
  Locale.use(conf.key, conf.pack);
}

// 支持的语言列表
export const SUPPORT_LOCALES = ['es', 'zh', 'en'];
// 默认语言(西班牙语,面向哥斯达黎加市场)
const DEFAULT_LOCALE = 'es';
// localStorage 中保存语言选择的 key
export const LOCALE_KEY = 'lang';

/**
 * 把浏览器的语言标识归一化为我们支持的语言
 * 例: zh-CN / zh-TW -> zh, es-CR -> es, en-US -> en
 */
function normalizeLocale(raw) {
  if (!raw) return null;
  const lower = String(raw).toLowerCase();
  if (lower.startsWith('zh')) return 'zh';
  if (lower.startsWith('es')) return 'es';
  if (lower.startsWith('en')) return 'en';
  return null;
}

/**
 * 决定初始语言:
 * 1. 上次手动选择(localStorage)
 * 2. 浏览器语言(navigator.languages / navigator.language)
 * 3. 默认西班牙语
 */
export function detectLocale() {
  // 1. 上次选择
  const saved = storage.getItem(LOCALE_KEY);
  if (saved && SUPPORT_LOCALES.includes(saved)) {
    return saved;
  }
  // 2. 浏览器语言
  const navLangs = (typeof navigator !== 'undefined' && (navigator.languages || [navigator.language])) || [];
  for (const lang of navLangs) {
    const matched = normalizeLocale(lang);
    if (matched) return matched;
  }
  // 3. 默认
  return DEFAULT_LOCALE;
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式,同时兼容选项式 $t
  globalInjection: true, // 让模板里可直接用 $t
  locale: detectLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { es, zh, en },
});

/**
 * 切换语言并持久化(默认保存1年)
 */
export function setLocale(locale) {
  if (!SUPPORT_LOCALES.includes(locale)) return;
  i18n.global.locale.value = locale;
  applyVantLocale(locale);
  storage.setItem(LOCALE_KEY, locale, new Date().getTime() + 1000 * 60 * 60 * 24 * 365);
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', locale);
  }
}

// 初始化:同步 html lang 和 Vant 语言
applyVantLocale(i18n.global.locale.value);
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', i18n.global.locale.value);
}

export default i18n;
